import gql from "graphql-tag";

const createLog = gql`
  mutation CreateLog(
    $category: String
    $menu: String
    $level: String
    $channel_id: String
    $message: String
  ) {
    createLog(
      input: {
        category: $category
        menu: $menu
        level: $level
        channel_id: $channel_id
        message: $message
      }
    ) {
      message
    }
  }
`;

const updateChannelByCM = gql`
  mutation UpdateChannel($id: String!, $name: String, $profile_image: String) {
    updateChannel(
      input: { id: $id, name: $name, profile_image: $profile_image }
    ) {
      id
      name
      profile_image
    }
  }
`;

// userRoles
const createUserRoles = gql`
  mutation CreateUserRoles($input: [CreateUserRoleInput]!) {
    createUserRoles(input: $input)
  }
`;

const deleteUserRoles = gql`
  mutation DeleteUserRoles($input: [DeleteUserRoleInput]!) {
    deleteUserRoles(input: $input)
  }
`;

const createFile = gql`
  mutation CreateFile(
    $channel_id: String
    $content_id: String
    $collection_id: String
    $mode: String
    $name: String
    $file_id: String
    $fileType: String
  ) {
    createFile(
      input: {
        channel_id: $channel_id
        content_id: $content_id
        collection_id: $collection_id
        mode: $mode
        name: $name
        file_id: $file_id
        fileType: $fileType
      }
    ) {
      name
      channel_id
      slide_id
      mode
      file_id
      url
      fileType
    }
  }
`;

const deleteFile = gql`
  mutation DeleteFile(
    $channel_id: String
    $mode: String
    $content_id: String
    $collection_id: String
    $name: String
  ) {
    deleteFile(
      input: {
        channel_id: $channel_id
        mode: $mode
        content_id: $content_id
        collection_id: $collection_id
        name: $name
      }
    ) {
      name
      channel_id
      content_id
      collection_id
      mode
    }
  }
`;

const createOnline = gql`
  mutation CreateOnline($input: CreateOnlineInput!) {
    createOnline(input: $input) {
      id
      mode
    }
  }
`;

const deleteOnline = gql`
  mutation DeleteOnline($input: DeleteOnlineInput!) {
    deleteOnline(input: $input) {
      id
      email
    }
  }
`;

// Group
const createGroup = gql`
  mutation CreateGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      id
      group_name
    }
  }
`;

const deleteGroup = gql`
  mutation DeleteGroup($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      channel_id
      group_name
      id
    }
  }
`;

const updateGroup = gql`
  mutation UpdateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      channel_id
      group_name
      id
    }
  }
`;

// Category
const createCategory = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
      category_name
      category_info
    }
  }
`;

const deleteCategory = gql`
  mutation DeleteCategory($input: DeleteCategoryInput!) {
    deleteCategory(input: $input) {
      channel_id
      id
    }
  }
`;

const updateCategory = gql`
  mutation UpdateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      channel_id
      category_name
      category_info
      id
    }
  }
`;

// Live
const createLive = gql`
  mutation CreateLive($input: CreateLiveInput!) {
    createLive(input: $input) {
      id
      title
      state
      start_date
      end_date
      when
      where
      when
      managers {
        email
      }
      stream_license_id
    }
  }
`;

const deleteLive = gql`
  mutation DeleteLive($input: DeleteLiveInput!) {
    deleteLive(input: $input) {
      id
      title
    }
  }
`;

const updateLive = gql`
  mutation UpdateLive($input: UpdateLiveInput!) {
    updateLive(input: $input) {
      id
      title
      stream_license_id
    }
  }
`;

// Content
const createContent = gql`
  mutation CreateContent($input: CreateContentInput!) {
    createContent(input: $input) {
      id
      title
      author
      channel_id
      created_at
      date
      info
      duration
      groups_can_access
      stream_mode
      stream_url
      autoplay
      mute
      size
      status
      thumbnails
      who
      key
      when
      when_start
      when_end
      where
      where_domains
    }
  }
`;

const updateContent = gql`
  mutation UpdateContent($input: UpdateContentInput!) {
    updateContent(input: $input) {
      id
      title
      author
      channel_id
      date
      info
      autoplay
      mute
      stream_mode
      stream_url
      status
      thumbnails
      tags
      categories
      poster
      poster_upload
      who
      key
      when
      when_start
      when_end
      where
      where_domains
      created_at
    }
  }
`;

const deleteContent = gql`
  mutation DeleteContent($input: DeleteContentInput!) {
    deleteContent(input: $input) {
      id
    }
  }
`;

// Collection
const createCollection = gql`
  mutation CreateCollection($input: CreateCollectionInput!) {
    createCollection(input: $input) {
      id
      title
      channel_id
      created_at
      info
      header
      who
      key
      when
      when_start
      when_end
      where
      where_domains
      mode_collection
      mode_api
      show_category
      show_item_author
      show_item_date
      show_item_view
      show_item_date_format
    }
  }
`;

const updateCollection = gql`
  mutation UpdateCollection($input: UpdateCollectionInput!) {
    updateCollection(input: $input) {
      id
      title
      channel_id
      created_at
      info
      back_img
      back_img_login
      header
      who
      key
      when
      when_start
      when_end
      where
      where_domains
      mode_collection
      mode_api
      show_category
      show_item_author
      show_item_date
      show_item_view
      show_item_date_format
    }
  }
`;

const deleteCollection = gql`
  mutation DeleteCollection($input: DeleteCollectionInput!) {
    deleteCollection(input: $input) {
      id
      title
    }
  }
`;

const updateDynamicLicense = gql`
  mutation UpdateDynamicLicense($input: UpdateDynamicLicenseInput!) {
    updateDynamicLicense(input: $input) {
      id
      channel_id
      stream_rtmp_urls
      stream_rtmp_keys
      stream_embed_urls
    }
  }
`;
export {
  createLog,
  createUserRoles,
  deleteUserRoles,
  updateChannelByCM,
  createFile,
  deleteFile,
  createOnline,
  deleteOnline,
  createGroup,
  deleteGroup,
  updateGroup,
  createCategory,
  deleteCategory,
  updateCategory,
  createLive,
  deleteLive,
  updateLive,
  createContent,
  updateContent,
  deleteContent,
  createCollection,
  updateCollection,
  deleteCollection,
  updateDynamicLicense
};
